import type { FC } from 'react';
import { Stack, Title } from '@mantine/core';

export const FilterSection: FC<{
  title?: string;
  children?: React.ReactNode;
}> = (props) => {
  const { title, children } = props;

  return (
    (title || children) && (
      <Stack gap="md">
        {title && (
          <Title order={3} fz="xxl">
            {title}
          </Title>
        )}
        {children}
      </Stack>
    )
  );
};
